import styled from 'styled-components';
import { shade, transparentize } from 'polished';

export const SolidBgButton = styled.button`
  background-color: ${(props) => props.color};
  border: 0;
  border-radius: 4px;
  width: 36px;
  height: 36px;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;

  &:hover,
  &:focus,
  &:active {
    background-color: ${(props) => shade(0.85, props.color)}
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 4px ${(props) => transparentize(0.7, shade(0.95, props.color))};
  }
`;

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s cubic-bezier(0.4, 0.0, 0.2, 1);
  transition-delay: 0.2s;
  color: white;

  ${SolidBgButton}:hover &,
  ${SolidBgButton}:focus & {
    transition-delay: 0s;

    ${(props) => props.back
    ? 'transform: translate3d(0, 0, 0);'
    : 'transform: translate3d(-100%, 0, 0);'
}
  }

  ${(props) => props.back && `
    transform: translate3d(100%, 0, 0);
  `}

  ${(props) => !props.back && `
    svg > *:not([fill-opacity]) {
      fill-opacity: 0.8;
    }
  `}
`;
